export const CHECK_DEVICE = 'CHECK_DEVICE';
export const CREATE_DEVICE = 'CREATE_DEVICE';
export const FETCH_SMS_NUMBER = 'FETCH_USER_NUMBER';

export const checkDeviceAction = (attemptCreate) => ({ 
    type: CHECK_DEVICE, 
    payload: { attemptCreate } 
  });
  export const createDeviceAction = () => ({
    type: CREATE_DEVICE
  });
  
  export const fetchSMSNumberAction = () => ({
    type: FETCH_SMS_NUMBER
  });